import { FeedbackItem, FeedbackType } from '../types';
import { getItem, setItem, FEEDBACK_KEY } from './storageService';

/**
 * Submit a new feedback item.
 * // TODO: Replace with API call
 */
export function submitFeedback(
  type: FeedbackType,
  message: string,
  page: string,
  rating?: 1 | 2 | 3 | 4 | 5
): FeedbackItem {
  const item: FeedbackItem = {
    id: crypto.randomUUID(),
    timestamp: Date.now(),
    type,
    message,
    page,
    rating,
    resolved: false,
  };

  const existing = getAllFeedback();
  existing.push(item);
  setItem(FEEDBACK_KEY, JSON.stringify(existing));

  return item;
}

/**
 * Get all feedback items.
 * // TODO: Replace with API call
 */
export function getAllFeedback(): FeedbackItem[] {
  const raw = getItem(FEEDBACK_KEY, '[]');
  try {
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

/**
 * Get count of unresolved feedback items.
 * // TODO: Replace with API call
 */
export function getUnresolvedCount(): number {
  return getAllFeedback().filter((f) => !f.resolved).length;
}
